import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const ColorGift = (param)=>{
    let { size = 48, testId, style, className } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_color_gift)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M38.2072 8.14152C38.0549 8.16557 37.9026 8.20164 37.7463 8.21367H30.8846V20.2938C30.5759 20.2938 30.2673 20.2938 29.9587 20.2938V46.8109C26.4076 46.8109 22.8485 46.8109 19.2974 46.8109V20.2938C18.9888 20.2938 18.6802 20.2938 18.3715 20.2938V8.20966C16.3595 8.10545 14.2152 8.34994 12.2192 8.20966C12.0709 8.20164 11.9627 8.15755 11.8305 8.13751C8.19919 7.58441 8.63606 2.84292 11.125 0.999236C13.0489 -0.427618 15.085 -0.323409 17.085 0.858955C19.085 2.04132 20.8685 3.41607 22.8244 4.57439C23.0769 4.47419 23.3014 4.2818 23.5619 4.19763C24.0789 4.0293 25.6461 4.0293 26.2192 4.09743C26.6361 4.14553 26.8846 4.38601 27.2573 4.49022L33.1812 0.666571C36.624 -1.42962 41.2293 1.44012 40.7563 5.46817C40.604 6.77078 39.4778 7.92509 38.2032 8.14152H38.2072ZM15.1571 2.54232C13.6781 2.74272 12.4477 4.23771 12.7042 5.74072C12.7844 6.22569 13.2934 6.67459 13.7864 6.72268C15.7383 6.91106 17.9908 6.57439 19.9747 6.72268C20.8204 6.62649 21.097 5.65254 20.4597 5.09944C19.9266 4.63451 17.3495 2.9792 16.7162 2.7307C16.2032 2.5303 15.7062 2.47419 15.1571 2.55034V2.54232ZM33.8545 2.54232C33.606 2.57839 33.2292 2.71066 32.9968 2.82288C32.3315 3.13551 30.0389 4.60645 29.5018 5.08741C28.8365 5.6806 29.089 6.63851 29.9948 6.72268C31.9467 6.91106 34.1992 6.57439 36.1832 6.72268C37.7303 6.39803 37.4016 4.59843 36.6441 3.6325C35.9908 2.79884 34.9006 2.40605 33.8545 2.54633V2.54232Z",
                        fill: "#8768F9"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M30.8845 20.2939C35.4296 20.2458 39.9907 20.3941 44.5318 20.2939V45.356C44.4797 46.1696 44.2192 46.6746 43.3575 46.8109C38.8925 46.8109 34.4236 46.8069 29.9587 46.8109V20.2939C30.2673 20.2939 30.5759 20.2939 30.8845 20.2939Z",
                        fill: "#A58EFB"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M18.3755 20.2939C18.6842 20.2939 18.9928 20.2939 19.3014 20.2939V46.8109C14.8365 46.8109 10.3675 46.8109 5.9026 46.8109C5.32144 46.7508 4.81643 46.2338 4.79639 45.6406V20.2939C9.31743 20.3941 13.8545 20.2458 18.3755 20.2939Z",
                        fill: "#A58EFB"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M38.2071 8.14151C38.2792 8.25774 38.4756 8.21365 38.5959 8.21365C40.9165 8.24171 43.2412 8.18961 45.5618 8.21365C46.1871 8.2858 46.632 8.84291 46.668 9.45614L46.66 19.1916C46.3995 20.41 45.5177 20.2778 44.5318 20.2978C39.9907 20.398 35.4296 20.2497 30.8845 20.2978V8.21365H37.7462C37.9025 8.20163 38.0548 8.16556 38.2071 8.14151Z",
                        fill: "#C3B3FC"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.8344 8.14151C11.9626 8.16155 12.0749 8.20564 12.2232 8.21365C14.2192 8.34993 16.3675 8.10544 18.3755 8.21365V20.2978C13.8544 20.2497 9.31736 20.398 4.79632 20.2978C3.85844 20.2778 3.02878 20.4301 2.66806 19.3319L2.69612 9.06335C2.86045 8.57438 3.25323 8.28179 3.76626 8.21365C6.32337 8.19361 8.88449 8.24171 11.4456 8.21365C11.5659 8.21365 11.7622 8.25774 11.8344 8.14151Z",
                        fill: "#C3B3FC"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_color_gift",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "48",
                        height: "48",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
